import React from "react";


const HeroSlide = ({
  image,
  eyebrow,
  title,
  description,
  buttonText,
  onButtonClick,
  detailUrl,
  moreInfoText
}) => {
  return (
    <section className="relative h-[85vh] min-h-[700px] overflow-hidden">

      {/* Background */}
      <div className="absolute inset-0">
        <img
          src={image}
          alt={eyebrow}
          className="h-full w-full object-cover object-[70%_30%] md:object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r 
        from-black/70 from-0%
        via-black/30 via-30%
          to-transparent to-70%">
        </div>
        
      </div>

      {/* Content */}
      <div className="relative z-10 mx-auto flex h-full max-w-7xl items-center px-6">

        <div className="max-w-2xl">

          {/* Eyebrow */}

          <span className="inline-flex items-center rounded-full border border-white/20 bg-white/10 px-5 py-2 backdrop-blur-md">

            <span className="mr-2 h-2 w-2 rounded-full bg-[#C8A56A]" />

            <span className="text-xs uppercase tracking-[0.35em] text-white">
              {eyebrow}
            </span>

          </span>

          <h1 className="mt-8 font-ivymode text-3xl leading-[0.92] text-white md:text-5xl xl:text-7xl whitespace-pre">
            {title}
          </h1>

          <p className="mt-8 max-w-xl text-lg leading-8 text-white/90 md:text-xl mb-10">
            {description}
          </p>
          <div className="flex flex-col gap-4 md:flex-row  items-center">
            

            <a
              href={detailUrl}
              className="w-[15rem] rounded-full px-10 md:px-8 py-4  shadow-lg hover:shadow-xl hover:bg-white 
              hover:text-dggreen text-white bg-dggreen text-xl md:text-2xl font-poppins border-2 border-dggreen text-center"
              >
                  {moreInfoText}
            </a>

              <button
                  onClick={onButtonClick}
                  className="w-[15rem]
                  rounded-full px-10 md:px-8 py-4 border-2 border-white
                text-white hover:bg-white hover:text-dggreen
                  text-xl md:text-2xl font-poppins transition text-center"
              >
                  <span className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent
                      via-white/70 to-transparent transition-transform duration-700 group-hover:translate-x-full" />

                  
                  {buttonText}
                  

            </button>
          </div>
          

        </div>

      </div>

    </section>
  );
};

export default HeroSlide;